import { OrganizationFeatures } from '@mode/shared/util-halogen';
import { OrgTypes } from '@mode/shared/contract-common';
import { AppStateFeatures } from './feature-flag-map';

export interface FeatureFlagState {
  type: string;
  context: string;
  contextName?: string;
}

export interface PlanFeatureFlagState extends FeatureFlagState {
  type: OrgTypes.PlanCode;
  context: OrgTypes.PlanCodeContext;
}

export interface OrganizationFeatureFlagState extends FeatureFlagState {
  type: OrganizationFeatures.Type;
  context: OrganizationFeatures.Context;
}

export interface AppStateFeatureFlagState extends FeatureFlagState {
  type: AppStateFeatures.Types;
  context: null;
}

export type FeatureFlagStateType = OrganizationFeatureFlagState | AppStateFeatureFlagState | PlanFeatureFlagState;

export function createFlag<T extends FeatureFlagState>(opts: T): T {
  return opts;
}
